import { createGlobalStyle } from 'styled-components';

import { Nav } from '#src/components/navigation/AppNavigation/index.tsx';
import { useSeriesNav } from '#src/hooks/commonGame/useSeriesNav.ts';
import { laptopAndAbove } from '#src/style/mediaQuery.ts';

const HideBottomNav = createGlobalStyle`
  :root {
    --bottom-bar-height-mobile: 0px !important;
  }
  ${Nav} {
    display: none;
    @media ${laptopAndAbove} {
      display: flex;
    }
  }
`;

export const HideSeriesBottomNav = () => {
  const seriesNav = useSeriesNav();
  if (!seriesNav) {
    return null;
  }
  return <HideBottomNav />;
};
